import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { ServiceOrderItemsActions } from '../actions';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.ServiceOrderItem };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    ServiceOrderItemsActions.CreateServiceOrderItem,
    ServiceOrderItemsActions.ReadServiceOrderItem,
    ServiceOrderItemsActions.ReadServiceOrderItems,
    ServiceOrderItemsActions.UpdateServiceOrderItem,
    ServiceOrderItemsActions.DeleteServiceOrderItem,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    ServiceOrderItemsActions.CreateServiceOrderItemSuccess,
    ServiceOrderItemsActions.UpdateServiceOrderItemSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    ServiceOrderItemsActions.ReadServiceOrderItemsSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: { [iri: string]: fromModuleModels.ServiceOrderItem },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    ServiceOrderItemsActions.DeleteServiceOrderItemSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    ServiceOrderItemsActions.CreateServiceOrderItemFail,
    ServiceOrderItemsActions.UpdateServiceOrderItemFail,
    ServiceOrderItemsActions.DeleteServiceOrderItemFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
